import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/governanceroom/clients/';
    const paths = {
        pathAdd: pathFrontEnd+'add',
        pathEdit: pathFrontEnd+'edit',
        pathView: pathFrontEnd+'view',
        endpoint: config.endpoints.backend+'governanceroom/clients/getall',
        endpointDelete: `${config.endpoints.backend}governanceroom/clients/delete`
    }
    
    let list = {
        labelTitle: 'Lista de Clientes',
        labelTitleButtonAdd: 'Novo Cliente',
        fieldsShowOnDelete: ['instance_name'],
        showPrintButtons: false,
        columns: [
            {
                name: 'cnpj',
                label: 'CNPJ'
            },
            {
                name: 'company_name',
                label: 'Razão Social'
            },
            {
                name: 'instance_name',
                label: 'Cliente'
            },
            {
                name: 'status_name',
                label: 'Status'
            }
        ],   
    };

    list = {...list,...paths};

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;
